export default __webpack_public_path__ + "f724f5aa9aef3518f7201a21275859d7.svg";